"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditCycleCountHistoryDetail = void 0;
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const uppercase_string_1 = require("shared/util/uppercase-string");
const columns = [
    {
        center: false,
        id: "ndc",
        numeric: false,
        label: "ndc"
    },
    {
        center: false,
        id: "name",
        numeric: false,
        label: "Name"
    },
    {
        center: true,
        id: "pkg",
        numeric: false,
        label: "pkg qty/form",
        sortable: false
    },
    {
        center: true,
        id: "hand count",
        numeric: false,
        label: "hand count",
        sortable: false
    },
    {
        center: true,
        id: "actual qty",
        numeric: false,
        label: "actual qty",
        sortable: false
    }
];
let EditCycleCountHistoryDetail = class EditCycleCountHistoryDetail extends react_1.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "name";
        this.filterText = "";
        this.cycleCountInventories = [];
        this.onHandleClickAddSite = () => {
            // RouteManager.transitionTo("/pharmacies/0");
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
        };
        this.onCallback = (value) => {
            this.filterText = value;
        };
        this.renderTableRow = (row, index) => {
            const { action, actualCountQty, blindCountQty, exceptionReason, qtyDifference, inventory: { name: inventoryName, package: pkg, ndc } } = row;
            return (React.createElement(list_item_1.MaterialListItem, { key: index },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: ndc }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: pkg }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: blindCountQty }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: actualCountQty })));
        };
        this.renderTable = () => (React.createElement("div", { className: "sites__list" },
            React.createElement(list_1.MaterialList, { columns: columns, 
                // onRequestSort={this.onRequestSort}
                order: this.order, orderBy: this.orderBy, 
                // rows={this.props.cycleCount.cycleCountInventories || []}
                rows: this.cycleCountInventories || [], renderRow: this.renderTableRow, resizableheader: true, customClass: "custom-material-list__cycle-count-history-details-list" })));
    }
    componentDidMount() {
        this.cycleCountInventories = this.props.cycleCount.cycleCountInventories;
        console.info("this.cycleCOuntInventories.length", this.cycleCountInventories.length);
    }
    componentWillReceiveProps(nextProps) {
        this.cycleCountInventories = this.props.cycleCount.cycleCountInventories;
        console.info("this.cycleCOuntInventories.length", this.cycleCountInventories.length);
    }
    render() {
        console.info("this.props.cycleCount", this.props.cycleCount);
        return this.renderTable();
    }
};
__decorate([
    mobx_1.observable
], EditCycleCountHistoryDetail.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountHistoryDetail.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountHistoryDetail.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountHistoryDetail.prototype, "cycleCountInventories", void 0);
EditCycleCountHistoryDetail = __decorate([
    mobx_react_1.observer
], EditCycleCountHistoryDetail);
exports.EditCycleCountHistoryDetail = EditCycleCountHistoryDetail;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/components/edit-cycle-count-history/components/edit-cycle-count-history-detail/edit-cycle-count-history-detail.tsx
// module id = 4113
// module chunks = 0